import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  gap: 20px;
`;

const Title = styled.h2`
  color: #252525;
  font-family: acumin-pro;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  text-align: center;
  margin: 0 0 10px 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
`;

interface RoleButtonProps {
  selected: boolean;
}

const RoleButton = styled.button<RoleButtonProps>`
  min-width: 200px;
  padding: 24px 32px;
  border-radius: 8px;
  border: 2px solid ${(props) => (props.selected ? '#D73714' : '#d6dce2')};
  background: ${(props) => (props.selected ? '#FFF5F3' : '#ffffff')};
  color: #252525;
  font-family: acumin-pro;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #D73714;
    background: #FFF5F3;
  }
`;

const NextButton = styled.button`
  margin-top: 10px;
  padding: 12px 40px;
  border-radius: 6px;
  border: none;
  background-color: #D73714;
  color: #ffffff;
  font-family: acumin-pro;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #b82e10;
  }

  &:disabled {
    background-color: #d6dce2;
    cursor: not-allowed;
  }
`;

const Phase0 = ({
  values,
  nextForm,
  setValue,
}: {
  values: { [key: string]: any };
  nextForm: () => void;
  setValue: Function;
}) => {
  const { t } = useTranslation();

  const handleSelect = (isIntern: boolean) => {
    setValue('is_intern', isIntern);
  };

  return (
    <Container>
      <Title>{t('select-role')}</Title>
      <ButtonGroup>
        <RoleButton
          type="button"
          selected={values.is_intern === true}
          onClick={() => handleSelect(true)}
        >
          {t('intern')}
        </RoleButton>
        <RoleButton
          type="button"
          selected={values.is_intern === false}
          onClick={() => handleSelect(false)}
        >
          {t('employee')}
        </RoleButton>
      </ButtonGroup>
      <NextButton
        type="button"
        disabled={values.is_intern === undefined || values.is_intern === null}
        onClick={nextForm}
      >
        {t('next')}
      </NextButton>
    </Container>
  );
};

export default Phase0;
